import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicationState } from '../../store';
import SharedMaterialsBrowser from './SharedMaterialsBrowser';
import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import * as Models from '../../store/Models/SharedMaterials/DataModel';
import { ToxnotComponent, ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import './SharedMaterialSupplier.css';
import { AppServices } from '../../AppServices';
import { RequestDataSupplierInfo, SurveyLocalStorageManager } from '../../store/Managers/SurveyLocalStorageManager';
import * as BrowserStateModels from "../../store/Models/SharedMaterials/BrowserStateModels";
import { rowPerPageValue } from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';


// At runtime, Redux will merge together...
type SharedMaterialSupplierProps =
    SharedMaterialsDatabaseStateController.SharedMaterialsState &
    ToxnotComponentProperties &
    typeof SharedMaterialsDatabaseStateController.actionCreators & // ... plus action creators we've requested
    RouteComponentProps<{ ownerId: string, companyId?: string }>;

class SharedMaterialSupplier extends ToxnotComponent<SharedMaterialSupplierProps> {
    
    private readonly _RowPerPageValue: number = rowPerPageValue;
    
    // ===============================================================================

    public async componentDidMount() {
        this.props.appServices.trackEvent("exchange-viewed-company-page");
        await this.props.loadSharedMaterialsIfNeeded(this.props.appServices, this.getQueryParameter("accessCode"), 0,'',this._RowPerPageValue, {}, BrowserStateModels.SortTypes.PassportName, BrowserStateModels.SortDirectionType.Ascending, this.props.match.params.companyId);
       
        await this.props.getSupplierFromIds(this.props.match.params.ownerId, this.props.match.params.companyId);
    }

    // ===============================================================================

    public render() {
        if (this.props.currentlySelectedSupplierState.isLoading || (this.props.currentlySelectedSupplierState.supplier === null)) {
            return (
                <div className="tn-section">
                    <div className="loading-container">{this.localizeString("Loading...")}</div>
                </div>
            );
        }

        return (
            this.renderMainSupplierForm(this.props.currentlySelectedSupplierState.supplier)
        );
    }

    // ===============================================================================

    private renderMainSupplierForm(supplier: Models.SharedMaterialsFullCompany) {
        const isUnClaimed = supplier.isUnClaimed;
        return (
            <div className="sm2-browser-root tn-section">
                <div className="sm2-browser-header">
                    <div className="tn-section-row">
                        <div className="tn-section-col-12">
                            {(this.props.history.length > 1)
                                ? (
                                    <button id="back-button" className="btn btn-default" onClick={e => this.props.history.goBack()}>{this.localizeString("Back")}</button>
                                )
                                : (
                                    <Link id="back-button" to={ToxnotReactComponentPaths.BaseSharedMaterialsPath} className="btn btn-default">{this.localizeString("Home")}</Link>
                                )
                            }
                        </div>
                    </div>
                    <div className="tn-section-row supplier-logo-and-details-container">
                        <div className="tn-section-col-4">
                            <div className="supplier-logo">
                                {(supplier.logoFileId !== null) && <img src={`/Api/GeneralFileImage?fileId=${encodeURIComponent(supplier.logoFileId)}&overrideTeamOwnerId=${encodeURIComponent(supplier.ownerId)}`} />}
                            </div>
                        </div>
                        <div className="tn-section-col-8">
                            <div className="supplier-details">
                                <div className="supplier-name-label-container">
                                    <h2 className="supplier-name mr-10">{supplier.name}</h2>
                                </div>
                                {supplier.companyInfo !== null &&
                                    <div className="supplier-branded-info">
                                        <a href={supplier.companyInfo.websiteUrl} target="_blank" rel="noopener noreferrer">{this.localizeString("Visit Company Website")}</a>
                                        <div className="supplier-description-container">
                                            {supplier.companyInfo.description.split('\n').map((s, index) => (
                                                <p key={index}>
                                                    {s.trim()}
                                                </p>
                                            ))}
                                        </div>
                                        <div className="supplier-action-buttons">
                                            {isUnClaimed ? (
                                                <p>{this.localizeString("Curated by 3E")}</p>
                                            ) : (
                                                <Link type="button" id="contact-supplier-button" to={ToxnotReactComponentPaths.ContactSupplier + "/" + encodeURIComponent(supplier.companyId)} onClick={e => this.contactSupplierButton_click()} className="btn btn-default ">{this.localizeString("Contact")}</Link>
                                            )}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="tn-section-row">
                        <div className="tn-section-col-12">
                            <div className="request-materials-and-access-buttons">
                                <button id="request-materials-button" onClick={e => this.requestNewMaterialsButton_click(supplier)} className="btn btn-default ">{this.localizeString("Request New Materials")}</button>
                                {" "}
                                {!isUnClaimed && (
                                    <button type="button" id="request-bulk-permission-button" onClick={e => this.requestBulkPermissionButton_onClick()} className="btn btn-default btn-warning">{this.localizeString("Request Access")}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <SharedMaterialsBrowser browserEndpoint={SharedMaterialsDatabaseStateController.BrowserEndpoint.Supplier} companyId={this.props.match.params.companyId} />
            </div>
        )
    }

    // ===============================================================================
    //
    // UI Events
    //
    // ===============================================================================

    private requestBulkPermissionButton_onClick = () => {
        const keys = Object.keys(this.props.supplierBrowserState.currentlySelectedSharedMaterialIds);

        if (keys.length === 0) {
            alert(this.localizeString("At least one material must be selected before requesting access"));
            return;
        }

        if (this.props.appServices.userContext === null) {
            AppServices.redirectToSignInPage();
            return;
        }

        this.props.requestAccessToSharedMaterials(keys);
        this.props.history.push(ToxnotReactComponentPaths.RequestAccessToSharedMaterial);
    }

    // ===============================================================================

    private contactSupplierButton_click = () => {
        this.props.initializeRequest();
    }

    // ===============================================================================

    private requestNewMaterialsButton_click = (supplier: Models.SharedMaterialsFullCompany) => {
        const requestDataSupplierInfo: RequestDataSupplierInfo = {
            existingSupplierIdsToInventoryIds: {},
            newSupplierNamesToEmail: {
                [supplier.name]: supplier.contactEmail
            }
        };

        const userContext = this.getUserContext();

        // Not signed in
        if (userContext === null) {
            AppServices.redirectToSignInPage();
            return;
        }

        const manager = new SurveyLocalStorageManager(userContext.userId);
        manager.setRequestDataSupplierInfo(requestDataSupplierInfo);

        this.props.history.push(ToxnotReactComponentPaths.GetStartedRequestData);
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ ...state.sharedMaterialsState, appServices: state.appServices }),
    SharedMaterialsDatabaseStateController.actionCreators // Selects which action creators are merged into the component's props
)(withRouter(SharedMaterialSupplier as any));
